<div>
  @if (label) {
    <span
      [ngClass]="{ 'inline-text-label': true, 'disabled':disabledFlag }"
      >
      {{label}}
    </span>
  }
  @if (!editMode) {
    <div class="selectPreviewData"
      (click)="editMode= !editMode"
      (keydown.space)="editMode= !editMode"
      (keydown.enter)="editMode= !editMode"
      aria-label='click to edit'
      >
      @if (selectedChoice) {
        <span>{{ selectedChoice }}</span>
      }
      @if (!selectedChoice) {
        <div>Click to edit</div>
      }
    </div>
  }
  @if (editMode) {
    <div class="editMode">
      <app-weave-radio-group
        [radioList]="items"
        [data]="selectedChoice"
        [showOptionsVertical]="true"
        (changed)="onFocusOut($event)"
      ></app-weave-radio-group>
    </div>
  }
</div>
